import { useLocation } from 'react-router';
import { PreAuthHeader } from '../../../components/PreAuthHeader/PreAuthHeader';
import { SelectCompanySignatoryRight } from '../../../components/SelectCompanySignatoryRight/SelectCompanySignatoryRight.js';

export const SelectCompanySignatoryRightPath = () => {
  const location = useLocation();
  const { contactSignatoryRights, individualDetails, showLinkedCompanies, redirectTo } = location.state ?? {};

  return (
    <>
      <PreAuthHeader isEoe={false} individualDetails={individualDetails} />
      <div id="select-signatory-rights">
        <SelectCompanySignatoryRight
          contactSignatoryRights={contactSignatoryRights}
          showLinkedCompanies={showLinkedCompanies}
          redirectTo={redirectTo}
        />
      </div>
    </>
  );
};
